module.exports = __webpack_public_path__ + "img/hero_portrait_crusader_female.5934c8f5.png";